import { render, staticRenderFns } from "./candidate-image.vue?vue&type=template&id=6d956e1c&"
import script from "./candidate-image.vue?vue&type=script&lang=js&"
export * from "./candidate-image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports